export const LEFT_COMPONENT_WIDTH = 320;
export const AVAILABILITY_WIDTH = 100;
export const COST_RATE_WIDTH = 100;
export const FILTERED_USERS_COLUMN_WIDTH = 180;
export const GROUP_RESOURCE_REQUESTS_PANEL_WIDTH = 300;
export const RESOURCE_COLUMN_DISPLAY_WIDTH = 220;
export const DEFAULT_WIDTH = 100;
